import { combineReducers } from 'redux';

import chat from './reducers/chat';
import remoteReducer from './reducers/remoteReducer';
import inventoryReducer from './reducers/inventoryReducer';
import enrollmentReducer from './reducers/enrollmentReducer';
import ctable from './app/common/own-table/ApiTable/reducers/ctable';
import idReducer from './reducers/idSlice'
import patchReducer from './reducers/patchReducer';

const rootReducer = combineReducers({
  // Define a top-level state field named `todos`, handled by `todosReducer`
  id: idReducer,
  inventory : inventoryReducer,
  remote: remoteReducer,
  chat: chat,
  enrollment: enrollmentReducer,
  ctable: ctable,
  patch : patchReducer,
})

export default rootReducer;